// extracted by mini-css-extract-plugin
var _1 = "hw97wak4gKY0GitVbvhe";
var _2 = "U3wGKvq0fiImyLIarsEU";
export { _1 as "list", _2 as "title" }
